import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-75d4c5f5")

_pushScopeId("data-v-75d4c5f5")
const _hoisted_1 = { class: "d-flex flex-column mb-5 fv-row" }
const _hoisted_2 = {
  key: 0,
  class: "d-flex align-items-center fs-6 fw-bold mb-2"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!

  return (_openBlock(), _createBlock("div", null, [
    _createVNode("div", _hoisted_1, [
      (_ctx.label != '' && _ctx.lable != true)
        ? (_openBlock(), _createBlock("label", _hoisted_2, [
            _createVNode("span", {
              class: { required: _ctx.required }
            }, _toDisplayString(_ctx.label), 3)
          ]))
        : _createCommentVNode("", true),
      _createVNode(_component_el_form_item, {
        prop: _ctx.name,
        rules: [
                    { required: _ctx.required, message: _ctx.translate(_ctx.requiredMsg) },
                    { type: _ctx.rule, message: _ctx.ruleMsg.value }
                ],
        class: "input-item"
      }, {
        default: _withId(() => [
          _createVNode(_component_el_input, {
            placeholder: _ctx.translate(_ctx.placeholder),
            name: _ctx.name,
            type: _ctx.type,
            min: _ctx.min,
            onInput: _ctx.updateValue,
            onBlur: _ctx.blurValue,
            modelValue: _ctx.inputValue,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.inputValue = $event)),
            value: _ctx.value,
            disabled: _ctx.disabled
          }, null, 8, ["placeholder", "name", "type", "min", "onInput", "onBlur", "modelValue", "value", "disabled"])
        ]),
        _: 1
      }, 8, ["prop", "rules"])
    ])
  ]))
})